const contact = {
  hero: {
    title: "Contact Us",
    subtitle: "We respond fast — usually within 2 hours!",
    methods: [
      { icon: "ri-phone-line", label: "Call / Text", value: "(561) 262-6118" },
      { icon: "ri-whatsapp-line", label: "WhatsApp", value: "Message Us" },
      { icon: "ri-mail-line", label: "Email", value: "adrimich7778@hotmail.com" },
    ],
  },
  form: {
    title: "Send Us a Message",
    subtitle: "Fill out the form and we'll get back to you shortly.",
    fields: {
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      service: "Service Needed",
      message: "Message",
      date: "Preferred Date",
      messagePlaceholder: "Tell us about your needs...",
      serviceOptions: [
        "Residential Cleaning",
        "Deep Cleaning",
        "Move-in / Move-out Cleaning",
        "Airbnb Cleaning",
        "Drywall Repair",
        "Door Repairs",
        "Cabinet & Drawer Fixes",
        "Interior Painting",
        "TV Mounting",
        "Furniture Assembly",
        "Pressure Washing",
        "Gutter Cleaning",
        "Fence Repairs",
        "Small Landscaping",
        "Other",
      ],
    },
    submit: "Send Message",
    sending: "Sending...",
    success: "Message sent! We'll contact you soon.",
    error: "Something went wrong. Please try again.",
    responseTime: "We respond within 2 hours",
  },
  info: {
    title: "Contact Information",
    address: { label: "Address", value: "10639 Misty Lane, Royal Palm Beach, FL 33411" },
    phone: { label: "Phone / Text / WhatsApp", value: "(561) 262-6118" },
    email: { label: "Email", value: "adrimich7778@hotmail.com" },
    schedule: { label: "Business Hours", value: "Mon – Sat: 8:00 AM – 4:00 PM" },
    payment: { label: "Payment Methods", value: "Cash · Zelle · Check" },
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      { q: "How quickly do you respond?", a: "We typically respond within 2 hours during business hours. For urgent requests, call or text us directly." },
      { q: "Do you offer free quotes?", a: "Yes! All quotes are completely free. Contact us and we'll assess your needs and provide a fair estimate." },
      { q: "What areas do you serve?", a: "We serve Royal Palm Beach, Wellington, West Palm Beach, Palm Beach Gardens, Lake Worth, and surrounding areas in Palm Beach County." },
      { q: "What payment methods do you accept?", a: "We accept Cash, Zelle, and Check. Payment is due upon completion of service." },
      { q: "Are you insured?", a: "Yes, we are a professional and trustworthy family business. Contact us for more details about our coverage." },
      { q: "Do you work on weekends?", a: "Yes! We work Monday through Saturday, 8:00 AM to 4:00 PM." },
    ],
  },
};

export default contact;
